import { render, staticRenderFns } from "./CreditsHeader.vue?vue&type=template&id=4a36d823&"
import script from "./CreditsHeader.vue?vue&type=script&lang=js&"
export * from "./CreditsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports